import ButtonGroup from "@visa/vds/button-group";
import ButtonText from "@visa/vds/button-text";
import Col from "@visa/vds/col";
import Grid from "@visa/vds/grid";
import Link from "@visa/vds/link";
import Row from "@visa/vds/row";
import MCSDragDropFileUpload from "components/MCSDragDropFileUpload";
import MCSProgressMessage from "components/MCSProgressMessage";
import React, { useState } from "react";
import { trackPromise, usePromiseTracker } from "react-promise-tracker";
import { useHistory } from "react-router-dom";
import { AlertMessages } from "_constants/AlertMessages";
import MCSHeader from "../../components/MCSHeader";
import MCSSpace from "../../components/MCSSpace";
import { GlobalAlertContext } from "../../context/GlobalAlertContext";
import { DafUploadApi } from "../../services/daf.upload.service";
import { DafUploadRoutes } from "../../_constants/PageRoutes";
import { FileHelper } from "../../_helpers/FileHelper";
import "../DAF/DafUpload.css";
import { DafUploadSuccessMessage } from "./Components/DafUpload/DafUploadSuccessMessage";

const DafUpload = () => {
  const history = useHistory();
  const [disableUploadButton, setDisableUploadButton] = useState(true);
  const [uploadFile, setUploadFile] = useState(null);
  const [dafUpload, setDafUpload] = useState(null);
  const { promiseInProgress } = usePromiseTracker();

  const updateUploadedFiles = async (files) => {
    setDafUpload(null);
    if (files == null || files.length == 0) setDisableUploadButton(true);
    else {
      setDisableUploadButton(false);
      let fileBytes = await FileHelper.ConvertFileToBase64(files[0]);
      setUploadFile({ fileName: files[0].name, fileData: fileBytes });
    }
  };

  const clickHandler = () =>
    history.push({
      pathname: DafUploadRoutes.DAF_UPLOAD_LIST,
    });

  const onClickUpload = async (alertObj) => {
    trackPromise(
      DafUploadApi.saveFile(uploadFile)
        .then((res) => {
          if (res.data.error != null) {
            alertObj.setErrorMessage(res.data.error.message);
          } else {
            setDafUpload(res.data);
          }
        })
        .catch((error) => {
          alertObj.setErrorMessage(AlertMessages.UnexpectedError);
        })
    );
    setUploadFile({
      fileName: null,
      fileData: null,
    });
    setDisableUploadButton(true);
  };

  return (
    <GlobalAlertContext.Consumer>
      {(alertObj) => (
        <>
          <Grid type="fluid">
            <MCSHeader header="Upload Acquirer File" />
            {dafUpload && <DafUploadSuccessMessage dafUpload={dafUpload} />}
            {promiseInProgress && (
              <MCSProgressMessage message="Security scan is being performed on the file..." />
            )}
            {!promiseInProgress && (
              <>
                <Row>
                  <Col>
                    <Link
                      onClick={clickHandler}
                      inline
                      aria-label="View Uploaded Files"
                    >
                      View Uploaded Files »
                    </Link>
                  </Col>
                </Row>

                <Row>
                  <Col xs={4} lg={8}>
                    <MCSDragDropFileUpload
                      accept=".xlsx,.xls"
                      label="3DS DAF Acquirer File"
                      multiple={false}
                      updateFilesCb={updateUploadedFiles}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col xs={4} lg={8}>
                    <ButtonGroup direction="right">
                      <ButtonText
                        disabled={disableUploadButton}
                        colorScheme="primary"
                        onClick={() => onClickUpload(alertObj)}
                      >
                        Upload
                      </ButtonText>
                    </ButtonGroup>
                  </Col>
                </Row>
              </>
            )}
          </Grid>
          <MCSSpace />
        </>
      )}
    </GlobalAlertContext.Consumer>
  );
};
export default DafUpload;
